/* eslint-disable max-len */
/* Note: this file is generated by "npm run template", please dont modify this file directly */
/* -- instead, you should modify "static-files/gant-legacy/tsconfig.json" and run "npm run template" */
import { ResultFile } from "@gant-lowcode/lowcode-types";

export default function getFile(): [string[], ResultFile] {
  return [
    ["."],
    {
      name: "tsconfig",
      ext: "json",
      content:
        '{\n  "compilerOptions": {\n    "target": "esnext",\n    "module": "esnext",\n    "moduleResolution": "node",\n    "resolveJsonModule": true,\n    "importHelpers": true,\n    "jsx": "react-jsx",\n    "esModuleInterop": true,\n    "sourceMap": true,\n    "baseUrl": "./",\n    "strict": true,\n    "paths": {\n      "@/*": ["src/*"],\n      "@@/*": ["src/.umi/*"]\n    },\n    "allowSyntheticDefaultImports": true\n  },\n  "include": [\n    "mock/**/*",\n    "src/**/*",\n    "config/**/*",\n    ".umirc.ts",\n    "typings.d.ts"\n  ],\n  "exclude": [\n    "node_modules",\n    "lib",\n    "es",\n    "dist",\n    "typings",\n    "**/__test__",\n    "test",\n    "docs",\n    "tests"\n  ]\n}\n',
    },
  ];
}
